module.exports = __webpack_public_path__ + "img/upload-alt.93a8526e.svg";